import { render, staticRenderFns } from "./GooglePaySvg.vue?vue&type=template&id=7c3eaa43&scoped=true&"
import script from "./GooglePaySvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GooglePaySvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3eaa43",
  null
  
)

export default component.exports